/**
 * Stale time for rarely changing data.
 *
 * 5 minutes
 */
export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
